export default {
  BASE_URL: '/cb/payment',
  api: [
    // 预付款变更
    {
      name: 'changeList',
      desc: '预付款变更列表',
      method: 'GET',
      path: '/receive/change/list'
    },
    {
      name: 'changeDetail',
      desc: '预付款变更详情',
      method: 'GET',
      path: '/receive/change/detail'
    },
    {
      name: 'change',
      desc: '新增变更',
      method: 'POST',
      path: '/receive/change/add'
    },
    {
      name: 'bindProject',
      desc: '选择项目收款',
      method: 'GET',
      path: '/receive/register/bind/project/list'
    },
    {
      name: 'selectProject',
      desc: '变更项目',
      method: 'GET',
      path: '/receive/change/selectProject'
    },
    {
      name: 'audit',
      desc: '审批',
      method: 'POST',
      path: '/receive/change/audit'
    },
    {
      name: 'changeDelete',
      desc: '删除',
      method: 'POST',
      path: '/receive/change/del'
    },
    {
      name: 'changePush',
      desc: '预付款变更-推动金蝶',
      method: 'POST',
      path: '/receive/change/push/kinDee'
    },
    // 付款登记
    {
      name: 'list',
      desc: '付款登记列表',
      method: 'GET',
      path: '/register/list'
    },
    {
      name: 'detail',
      desc: '付款登记详情',
      method: 'GET',
      path: '/register/detail'
    },
    {
      name: 'add',
      desc: '新增付款登记',
      method: 'POST',
      path: '/register/add'
    },
    {
      name: 'submit',
      desc: '绑定提交',
      method: 'POST',
      path: '/register/bind'
    },
    {
      name: 'bindCancel',
      desc: '解绑',
      method: 'POST',
      path: '/register/bindCancel'
    },
    {
      name: 'delete',
      desc: '删除',
      method: 'POST',
      path: '/register/del'
    },
    {
      name: 'purchaseList',
      desc: '采购订单列表',
      method: 'GET',
      path: '/register/purchase/list'
    },
    {
      name: 'import',
      desc: '导入付款登记',
      method: 'POST',
      path: '/register/import'
    },
    {
      name: 'importTemplate',
      desc: '导入付款登记模板',
      method: 'GET',
      path: '/register/import/tempInstall'
    },
    {
      name: 'importOrder',
      desc: '导入采购订单',
      method: 'POST',
      path: '/register/order/import'
    },
    {
      name: 'orderTemplate',
      desc: '导入采购订单',
      method: 'GET',
      path: '/register/order/import/tempInstall'
    },
    {
      name: 'log',
      desc: '变更记录',
      method: 'GET',
      path: '/register/log/list'
    },
    {
      name: 'changeBind',
      desc: '换绑',
      method: 'POST',
      path: '/register/bind/change'
    },
    {
      name: 'selectReceipt',
      desc: '选择收款单',
      method: 'GET',
      path: '/register/selectBill'
    },
    {
      name: 'push',
      desc: '推送金蝶',
      method: 'POST',
      path: '/register/push/kinDee'
    },
    // 付款绑定记录
    {
      name: 'bindOrderRecords',
      desc: '采购订单绑定记录',
      method: 'GET',
      path: '/register/bind/order/list'
    },
    {
      name: 'bindProjRecords',
      desc: '冲销项目收款记录',
      method: 'GET',
      path: '/register/bind/reverse/list'
    },
    {
      name: 'bindCancelRecords',
      desc: '付款冲销绑定记录',
      method: 'GET',
      path: '/register/bind/return/list'
    },
    // 冲销付款
    {
      name: 'reverseList',
      desc: '冲销付款列表',
      method: 'GET',
      path: '/reverse/list'
    },
    {
      name: 'reverseDetail',
      desc: '冲销付款详情',
      method: 'GET',
      path: '/reverse/detail'
    },
    {
      name: 'addReverse',
      desc: '冲销付款-收款登记',
      method: 'POST',
      path: '/reverse/add'
    },
    {
      name: 'submitReverse',
      desc: '冲销付款-绑定',
      method: 'POST',
      path: '/reverse/bind'
    },
    {
      name: 'delReverse',
      desc: '冲销付款-删除',
      method: 'POST',
      path: '/reverse/del'
    },
    {
      name: 'reverseLog',
      desc: '冲销付款-日志',
      method: 'GET',
      path: '/reverse/log/list'
    },
    {
      name: 'importReverse',
      desc: '冲销付款-导入',
      method: 'POST',
      path: '/reverse/import'
    },
    {
      name: 'importReverseTemp',
      desc: '冲销付款-导入模板',
      method: 'GET',
      path: '/reverse/import/tempInstall'
    },
    {
      name: 'reversePush',
      desc: '冲销付款-推送金蝶',
      method: 'POST',
      path: '/reverse/push/kinDee'
    },
    {
      name: 'bankAccount',
      desc: '金蝶推送银行帐号-下拉',
      method: 'GET',
      path: '/register/kinDee/bankAccount'
    },
    {
      name: 'confirm',
      desc: '付款单-确认',
      method: 'POST',
      path: '/register/confirm'
    }
  ]
}


// WEBPACK FOOTER //
// ./src/api/apis/self/statement/payment.js